(function () {
    'use strict';

    if (typeof window === 'undefined') return;
    if (window.__CATALOG_BUNDLES_BOOTSTRAP_LOADED__) return;
    window.__CATALOG_BUNDLES_BOOTSTRAP_LOADED__ = true;

    var ENDPOINT = 'https://database-app-2-lcae.onrender.com/api/bundle-components';

    var CACHE_PREFIX = '__catalogBundleProxy:';
    var CACHE_TTL_MS = 60 * 60 * 1000;
    var BATCH_SIZE = 50;

    function _now() { return Date.now(); }

    function _readCache(handle) {
        try {
            var raw = sessionStorage.getItem(CACHE_PREFIX + handle);
            if (!raw) return null;
            var parsed = JSON.parse(raw);
            if (!parsed || typeof parsed.t !== 'number') return null;
            if (_now() - parsed.t > CACHE_TTL_MS) return null;
            return parsed;
        } catch (e) { return null; }
    }

    function _writeCache(handle, info) {
        try {
            sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify({
                isBundle: !!info.isBundle,
                components: Array.isArray(info.components) ? info.components : [],
                t: _now()
            }));
        } catch (e) {}
    }

    function _patchCatalog(handle, info) {
        if (!window.__shopifyCatalog || !window.__shopifyCatalog.products) return;
        var entry = window.__shopifyCatalog.products[handle];
        if (!entry) return;
        entry.isBundle = !!info.isBundle;
        if (Array.isArray(info.components)) entry.components = info.components;
        window.__shopifyCatalog._bundlesOf = null;
        window.__shopifyCatalog._productsInCollection = null;
        window.__shopifyCatalog._productsWithTag = null;
    }

    function _waitForCatalog(maxAttempts, cb) {
        var attempts = 0;
        function tick() {
            attempts += 1;
            if (window.Catalog && typeof window.Catalog.knownHandles === 'function') {
                cb();
                return;
            }
            if (attempts >= maxAttempts) return;
            setTimeout(tick, 100);
        }
        tick();
    }

    function _chunk(arr, size) {
        var out = [];
        for (var i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
        return out;
    }

    function _fetchBatch(handles) {
        var url = ENDPOINT + '?handles=' + encodeURIComponent(handles.join(','));
        return fetch(url, {
            method: 'GET',
            credentials: 'omit',
            headers: { 'Accept': 'application/json' }
        }).then(function (r) {
            if (!r.ok) return null;
            return r.json();
        }).then(function (payload) {
            if (!payload || !payload.products) return;
            for (var h in payload.products) {
                if (!Object.prototype.hasOwnProperty.call(payload.products, h)) continue;
                var info = payload.products[h];
                _writeCache(h, info);
                if (info && info.isBundle) _patchCatalog(h, info);
            }
        }).catch(function () {});
    }

    function _bootstrap() {
        if (!window.Catalog || !window.__shopifyCatalog) return;
        var allHandles = window.Catalog.knownHandles();
        if (!allHandles.length) return;

        var candidates = allHandles.filter(function (h) {
            return !window.Catalog.isBundle(h);
        });
        if (!candidates.length) return;

        var uncached = [];
        candidates.forEach(function (h) {
            var cached = _readCache(h);
            if (cached) {
                if (cached.isBundle) _patchCatalog(h, cached);
                return;
            }
            uncached.push(h);
        });

        if (!uncached.length) return;

        var batches = _chunk(uncached, BATCH_SIZE);
        batches.forEach(function (batch) { _fetchBatch(batch); });
    }

    _waitForCatalog(30, _bootstrap);
})();
